import shuffleLetters from 'shuffle-letters';

class ShuffleText {
  constructor(el) {
    this.dom = {el: el};
    // console.log(this.dom.el)
    // this.dom.viewContainer = this.dom.el.querySelector('[data-js="code-shuffle"]');
    this.dom.viewTexts = this.dom.el.querySelectorAll('[data-js="shuffle-animation"]');

    this.len = this.dom.viewTexts.length - 1;
    this.finished = false;
    // console.log(this.len)

    // this.init();
  }

  start(index) {
    const _this = this;
    [...this.dom.viewTexts].forEach((txt, i) => {
      if (this.len === i) this.finished = true;
      setTimeout(()=>{
        shuffleLetters(txt, {
          text: txt.dataset.text,
          iterations: 24,
          fps: 60,
          onComplete: el => {
            // console.log('Effect was completed.');
            _this.dom.el.classList.add('is-finished');
          }
        });
      }, 600 * index);
      // console.log({i}, '/', this.len);
    })
  }
}

export default ShuffleText